import { render, staticRenderFns } from "./ourServiceMainPage.vue?vue&type=template&id=0ec6317b&scoped=true&"
import script from "./ourServiceMainPage.vue?vue&type=script&lang=js&"
export * from "./ourServiceMainPage.vue?vue&type=script&lang=js&"
import style0 from "./ourServiceMainPage.vue?vue&type=style&index=0&id=0ec6317b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec6317b",
  null
  
)

export default component.exports